import './_style.scss'
import Listener from '../../core/watcher/Listener'

document.documentElement.scrollWidth > 1360
&& document.documentElement.scrollHeight > 1360
&& Listener.onLoadDOM(() => {
   fillTableOfContent()

   const className = 'tableOfContent__open-block__visible'
   const table = document.querySelector('.tableOfContent__open-block')

   document.querySelector('.tableOfContent__block')?.addEventListener('click', (e) => {
      e.preventDefault()
      table?.classList.add(className)
   })

   document.querySelector('.tableOfContent__open-block__cross')?.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()
      table?.classList.remove(className)
   })
})

const fillTableOfContent = () => {
   const contentListRef = document.querySelector('.tableOfContent__list')
   document.querySelectorAll('H1, H2, H3').forEach(item => {
      if (item.textContent !== '' && item.textContent !== null) {
         item.id = item.textContent.toLowerCase().replace(/[^\d\w\s]|_/g, '').trim().split(' ').join('-')
         contentListRef?.insertAdjacentHTML(
            'beforeend',
            `<li class='tableOfContent__item'><a class='tableOfContent__link' href='#${item.id}'>${item.textContent}</a></li>`,
         )
         contentListRef.addEventListener('click', (e) => {
            if (e.target.textContent === item.textContent) {
               e.preventDefault()
               setTimeout(() => {
                  window.scrollTo({
                     top: item.offsetTop - 150,
                     behavior: 'smooth',
                  })
               }, 500)
            }
         })
      }
   })
}

